import { CustomToastrAction, toastr, TRANSLATION, Yup, REDIRECT } from "@/imports-files/common/common";
import { addParamsToUrl } from "@/imports-files/pages/clients/candidates/kanban";
import { ScorecardImportService } from "@/services/components/scorecard-import";

export class ScorecardImportAction{
  constructor(args)
  {
    this.scorecardImportService  =  new ScorecardImportService();
    this.customToastrAction     =  new CustomToastrAction();
    this.setApiError            =  args.setApiError;
    this.router                 =  args.router;
    this.setTemplateList        =  args.setTemplateList;
  }

  async loadTemplateList(string){
    const result    =   await this.scorecardImportService.templatelist({per_page: 30, search_text: string});
    if(result.request.status == 200){
      return result.data.list.map((template) => {
        return {
          label: template.title,
          value: template.id
        }
      });
    }
    else {
      return []
    }
  }

  async submitForm(job_id, template_id, setScoreCardImport){
    const result = await this.scorecardImportService.importScorecard(job_id, template_id);
    if(result.request.status == 200){
      this.customToastrAction.setNormalToastr(result.data.success, 'success')
      return {scorecard_config_attributes: result.data.scorecard_config_attributes, job_competencies_attributes: result.data.job_competencies_attributes}
    }
    else {
      this.customToastrAction.setNormalToastr(result.response.data.error, 'error')
    }
  }

  redirectToCreateTemplate(jobId, router){
    this.router.push(REDIRECT.client.recruitment.scorecard_templates+`?redirect_id=${jobId}`)
  }
}